// Widget Scripts
import customTicketButton from './js/widgets/customTicketButton.js';
import mainSlideshow from './js/widgets/mainSlideshow.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import videoWidget from './js/widgets/videoWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import cardWidget from './js/widgets/cardWidget.js';
import gridGallery from './js/widgets/gridGallery.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';

// Custom Theme Scripts
import './js/localjs.js';
import './js/utils.js';

if (window.location.pathname === '/') {
  $(document).ready(function () {
    mainSlideshow();
    multiScheduleFeature();
    seoWidget();
    cardWidget();
    gridGallery();
    scrollerSponsors();

    $(window).load(function () {
      videoWidget();
    });
  });
}

$(document).ready(function () {
  customTicketButton();
});
